import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl text-left font-bold text-neutral-900 border-b border-b-black/[.10] py-3" }
const _hoisted_2 = { class: "space-y-6 text-left" }
const _hoisted_3 = { class: "flex justify-end items-center space-x-3" }

import BaseModal from '@/components/modals/BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: "p-6 w-[480px] space-y-6",
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "button")
      ])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})